import React from "react";
import { Button, Modal } from "@tecma/ds";
import useModal from "hooks/useModal";

const ModalActions = () => {
  const { isOpen, title, content, leftActionProps, rightActionProps, onClose } =
    useModal();
  return (
    <Modal
      data-testid='coliving-modalActions'
      isOpen={isOpen}
      onClose={onClose}
      verticalPosition='center'
    >
      <Modal.Header onClose={onClose} closeIcon>
        {title}
      </Modal.Header>
      <Modal.Content>{content}</Modal.Content>
      <Modal.Footer>
        {leftActionProps ? <Button {...leftActionProps} /> : null}
        {rightActionProps ? <Button {...rightActionProps} /> : null}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalActions;
